getSupertypeSet